import { render, staticRenderFns } from "./AgendaSession.vue?vue&type=template&id=0d1a13b8&scoped=true&"
import script from "./AgendaSession.vue?vue&type=script&lang=js&"
export * from "./AgendaSession.vue?vue&type=script&lang=js&"
import style0 from "./AgendaSession.vue?vue&type=style&index=0&id=0d1a13b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a13b8",
  null
  
)

export default component.exports